import { Box, Image } from '@chakra-ui/react';
import previewTrialBanner from '../../../../../assets/vectors/previewTrialBanner.png';

interface TrialBannerOverlayProps {
  isInTrial: boolean;
}

export const TrialBannerOverlay = ({ isInTrial }: TrialBannerOverlayProps) => {
  if (!isInTrial) {
    return null;
  }

  return (
    <>
      <Box
        position="absolute"
        top="0"
        left="0"
        right="0"
        bottom="0"
        bg="#212121"
        opacity={0.4}
        zIndex={0}
        pointerEvents="none"
        borderRadius="inherit"
      />
      <Box
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        pointerEvents="none"
        w="100%"
      >
        <Image
          src={previewTrialBanner}
          alt="Trial Pass banner watermark"
          objectFit="contain"
        />
      </Box>
    </>
  );
};
